const initLoadMoreNews = () => {
  const newsList = document.querySelectorAll( '.news-archive__list' );
  let currentPage = 1;
  let postsPerPage = 10;

  if (!newsList || newsList.length === 0) {
    return;
  }

  const updateSeenCount = list => {
    const seenCount = list.querySelector( '.load-more-seen-count' );
    const newsItems = list.querySelector( '.news-archive__items' );
    const progressBar = list.querySelector( '.load-more__progress-bar' );
    const maxCount = list.querySelector( '.load-more-max-count' );
    const showMoreButton = list.querySelector( '.load-more button' );

    if (!seenCount || !newsItems || !progressBar || !maxCount || !showMoreButton) {
      return;
    }

    progressBar.style.width = (newsItems.querySelectorAll( 'li' ).length / parseInt( maxCount.innerText, 10 ) * 100) + '%';
    seenCount.innerText = newsItems.querySelectorAll( 'li' ).length;

    if (seenCount && seenCount.innerText === maxCount.innerText) {
      showMoreButton.style.display = 'none';
    }
  }

  async function fetchMoreNews() {
    try {
      const response = await fetch( ajaxurl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams( {
          action: 'load_more_news',
          paged: currentPage + 1,
          posts_per_page: postsPerPage
        } )
      } );

      if (!response.ok) {
        throw new Error( 'Network response was not ok' );
      }

      const data = await response.json();

      if (data.success) {
        newsList.forEach( list => {
          const newsItems = list.querySelector( '.news-archive__items' );
          newsItems.insertAdjacentHTML( 'beforeend', data.data.html );
          const firstNewNews = newsItems.children[(currentPage) * postsPerPage];
          if (firstNewNews) {
            firstNewNews.scrollIntoView( { behavior: 'smooth' } );
            firstNewNews.focus();
          }
          currentPage++;
          updateSeenCount( list );
        } );
      } else {
        console.error( 'Error loading more news:', data.data.message );
      }
    } catch (error) {
      console.error( 'Fetch error:', error );
    }
  }

  if (newsList.length > 0) {
    [...newsList].forEach( list => {
      const showMoreButton = list.querySelector( '.load-more button' );

      updateSeenCount( list );

      if (!showMoreButton) {
        return;
      }

      showMoreButton.addEventListener( 'click', event => {
        event.preventDefault();
        fetchMoreNews();
      } );
    } );
  }
}

export default initLoadMoreNews;